<template>
<!-- 学员信息 -->
    <div class="stuInfo">
        <div  class="search-content conditionSearchBox">
            <div class="conditionItem">
                <el-input size="medium"  prefix-icon="el-icon-search" placeholder="姓名" v-model="params.condition.keyword" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium"  prefix-icon="el-icon-search" placeholder="标签" v-model="params.condition.label" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium"  prefix-icon="el-icon-search" placeholder="联系方式" v-model="params.condition.telno" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="hollowOut" @click="triggerSearch">
                    <i class="el-icon-search mr-5"></i>搜索</el-button>
                <el-button @click="resetSearchCondition">
                    <i class="el-icon-refresh mr-5"></i>重置</el-button>
            </div>
        </div>
        <div class="listBox mt-20">
            <el-button @click="addStudents('')" type="primary"><span class="icon-add">+</span>新增学员</el-button>
             <!-- 表格 -->
             <div v-loading="loadingStatus" class="table-content mt-15">
                <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                    <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                        fixed="left">
                        <template slot-scope="scope">
                            <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                        </template>
                    </el-table-column>
                    <el-table-column width="120" key="nickname" align="center" prop="nickname" label="昵称">
                        <template slot-scope="scope">
                            <span class="jumpname" @click="goPage(scope.row)">{{scope.row.nickname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" key="name" align="center" prop="name" label="姓名">
                    </el-table-column>
                    <el-table-column width="100" key="sexname" align="center" prop="sexname" label="性别">
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="campusname" align="center" prop="campusname" label="所在校区">
                    </el-table-column>
                    <el-table-column min-width="120" key="telno" align="center" prop="telno" label="联系方式">
                    </el-table-column>
                    <el-table-column width="100" key="periodcounton" align="center" prop="periodcounton" label="到课数">
                    </el-table-column>
                    <el-table-column width="100" key="periodcountoff" align="center" prop="periodcountoff" label="未到数">
                    </el-table-column>
                    <el-table-column width="100" key="periodcountleave" align="center" prop="periodcountleave" label="请假数">
                    </el-table-column>
                    <el-table-column width="100" key="totalscore" align="center" prop="totalscore" label="完成学分数">
                    </el-table-column>
                    <el-table-column width="100" key="statusname" align="center" prop="statusname" label="状态">
                    </el-table-column>
                    <el-table-column width="140" key="recenttclasstime" align="center" prop="recenttclasstime" label="入班时间">
                    </el-table-column>
                    <el-table-column :width="getTableHeaderWidthByOpButton2()" fixed="right" key="set" align="right" label="操作">
                        <template slot-scope="scope">
                            <div class="color-brand flex jc-sb ai-c pointer">
                                <span v-if="scope.row.status == 10 || scope.row.status == 0" @click="loading(scope.row)" class="color-brand pointer">暂停</span>
                                <span v-if="scope.row.status == 11" @click="replay(scope.row)" class="color-brand pointer">恢复</span>
                                <span v-if="scope.status!=100" @click="del(scope.row)"  class="color-brand pointer">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :hide-on-single-page="!total || total < 1"
                    class="mt-20 flex ai-c jc-fd"
                    @size-change="handePageSizeChange"
                    @current-change="curPageChange"
                    @prev-click="curPageChange"
                    @next-click="curPageChange"
                    layout="total, sizes, prev, pager, next"
                    :total="total"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    :page-size="20"
                    :current-page.sync="params.page"
                    background
                ></el-pagination>
            </div>
        </div>
        <!-- 新增学员 -->
        <AddStudent  ref="AddStudent" @saveSuccess="saveSuccess" />
    </div>
</template>
<script>
import {getClassStudentList,updateStudentStatus} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import AddStudent from '@/views/meas/studentManage/studentManage/components/addStudent.vue'
export default {
    data(){
        return {
            tableData: [],
            loadingStatus: false,
            total: 0,
            params: {
                condition: {
                    classcode: this.$route.query.code,
                    keyword: '',
                    label: '',
                    nickname: '',
                    status: '',
                    telno: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            stuList: [],
            changeStatus: {
                classcode: this.$route.query.code,
                codes: '',
                status: ''
            },
            step: 1
        }
    },
    components: {
        TableSort,
        AddStudent
    },
    created(){
    //    this.getStudentList() 
    },
    methods: {
        init(){
            if(this.step === 1){
                this.getStudentList()
            } 
        },
        getStudentList(){
            this.loadingStatus = true
            getClassStudentList(this.params).then(res => {
                this.loadingStatus = false
                if(res.code === '000'){
                    this.step++
                    this.tableData = res.data
                    this.total = res.pageinfo.rowcount
                }
                console.log(res,'学员列表')
            }).catch(err => {
                this.loadingStatus = false
            })
        },
        triggerSearch(){
            this.params.page = 1
            this.getStudentList()
        },
        resetSearchCondition(){
            this.params.page = 1
            this.params.condition.keyword = ''
            this.params.condition.label = ''
            this.params.condition.telno = ''
            this.getStudentList()
        },
        // 保存成功
        saveSuccess() {
            this.params.page = 1
            this.getStudentList()
        },
        addStudents(code){
            // 打开新增编辑学员
            this.$refs.AddStudent.handleOpen(code, this.$route.query.code)
        },
        loading(item){
            this.changeStatus.codes = item.studentcode 
            this.changeStatus.status = 11
            this.$confirm('学员暂停之后将无法正常在该班级学习，继续吗？', '暂停', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'measElMessage'
            }).then(() => {
                this.updateStudentStatus()
            })
        },
        replay(item){
            this.changeStatus.codes = item.studentcode 
            this.changeStatus.status = 10
            this.updateStudentStatus()
        },
        del(item){
            this.changeStatus.codes = item.studentcode
            this.changeStatus.status = 100
            this.$confirm('学员删除之后将无法正常在该班级学习，继续吗？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'measElMessage'
            }).then(() => {
                this.updateStudentStatus()
            })
        },
        updateStudentStatus(){
            updateStudentStatus(this.changeStatus).then(res => {
                this.$message.success(res.msg)
                this.getStudentList()
                console.log(res)
            })
        },
        goPage(row){
            this.$router.push({name: 'StudentDetails', query: {code: row.studentcode, classCode: this.$route.query.code}})
        },
        handePageSizeChange(e){
            this.params.page = 1
            this.params.pagesize = e
            this.getStudentList()
        },
        curPageChange(e){
            console.log(e,'eee')
            this.params.page = 1
            this.params.page = e
            this.getStudentList()
        },
    }
}
</script>
<style lang="scss" scoped>
.stuInfo{
    .jumpname{
        color: #409EFF;
        cursor: pointer;
    }
    .listBox{
        font-size: 14px;
        .icon-add{
            margin-right: 6px;
        }
    }
}

</style>